﻿import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AgmCoreModule } from '@agm/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { LookupComponent } from './shared/lookup/lookup.component';
import { AutoCompleteComponent } from './shared/geoautocomplete/auto-complete.component';
import { AutoCompleteSearchService } from './shared/geoautocomplete/auto-complete.service';

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        AgmCoreModule.forRoot({
          apiKey: 'AIzaSyDlNOgCi3bkzsoaU853u7iOzryqMEU7nGY',
          libraries: ['places']
        })
    ],
    declarations: [
        AppComponent,
        LookupComponent,
        AutoCompleteComponent
    ],
    bootstrap: [AppComponent],
    providers: [AutoCompleteSearchService],
    entryComponents: [
        LookupComponent
    ]
})

export class AppModule { }//